import React from 'react';
import { Field } from 'react-final-form';
import InputField from '../../../components/InputField';
import DescriptionField from '../../../components/DescriptionField';
import DataListField from '../../../Common/components/DataListField';
import Validators, { required, isNumber, validateDocument } from '../../../Common/validators';
import { normalizeDocument, normalizeValue } from '../../../Common/normalize';

const fourDigits = data => {
  if (data.length > 4 && data != undefined) {
    return "A agência deve ter no máximo 4 dígitos"
  }

  return undefined;
}

const thirteenDigits = data => {
  if (data.length > 13 && data != undefined) {
    return "A conta deve ter no máximo 13 dígitos"
  }

  return undefined;
}

export const FormBody = ({ handleSubmit, invalid, banks }) => {
  const optionsBank = banks.map(bank =>
    <option key={bank.code} value={bank.code}>{bank.code} - {bank.name}</option>
  );

  return (
    <form onSubmit={handleSubmit}>
      <div className="pl-lg-4">
        <div className="row">
          <div className="col-12 col-md-12">
            <Field
              name="transfer.bank"
              type="text"
              className="form-control"
              label="Banco"
              validate={Validators(required)}
              options={optionsBank}
              component={DataListField}
            />
          </div>
        </div>
        <div className="row">
          <div className="col-6 col-md-4">
            <Field
              name="transfer.agency"
              type="text"
              className="form-control"
              label="Agência"
              validate={Validators(required, fourDigits, isNumber)}
              component={InputField}
            />
          </div>
          <div className="col-6 col-md-2">
            <Field
              name="transfer.agencyDigit"
              type="text"
              className="form-control"
              label="Dígito"
              validate={Validators(isNumber)}
              component={InputField}
            />
          </div>
          <div className="col-6 col-md-4">
            <Field
              name="transfer.account"
              type="text"
              className="form-control"
              label="Conta"
              validate={Validators(required, thirteenDigits, isNumber)}
              component={InputField}
            />
          </div>
          <div className="col-6 col-md-2">
            <Field
              name="transfer.accountDigit"
              type="text"
              className="form-control"
              label="Dígito"
              validate={Validators(required, isNumber)}
              component={InputField}
            />
          </div>
        </div>
        <div className="row">
          <div className="col-12 col-md-4">
            <Field
              name="transfer.name"
              type="text"
              className="form-control"
              label="Nome"
              validate={Validators(required)}
              component={InputField}
            />
          </div>
          <div className="col-12 col-md-4">
            <Field
              name="transfer.document"
              type="text"
              className="form-control"
              label="CPF ou CNPJ"
              parse={normalizeDocument}
              validate={Validators(required, validateDocument)}
              component={InputField}
            />
          </div>
          <div className="col-12 col-md-4">
            <Field
              name="transfer.amount"
              type="text"
              className="form-control"
              label="Valor"
              parse={normalizeValue}
              validate={Validators(required)}
              component={InputField}
            />
          </div>
        </div>
        <div className="row">
          <div className="col-12 col-md-12">
            <Field
              name="transfer.description"
              label="Descrição"
              validate={Validators(required)}
              className="form-control"
              component={DescriptionField}
            />
          </div>
        </div>
      </div>
      <div className="text-center">
        <button
          type="submit"
          className="btn btn-success mt-4"
          disabled={invalid}>
          Enviar
        </button>
      </div>
    </form>
  );
}


// WEBPACK FOOTER //
// ./src/ZWallet/Transfer/components/Form.js